const cancerDeProstataChange = fields => {
  let calcGleason = function() {
    let som =
      parseInt(fields['gleason1_pros'].current.value) +
      parseInt(fields['gleason2_pros'].current.value);
    fields['gleason_pros'].current.value = !isNaN(som) ? som : null;
    fields['gleason_pros'].current.dispatchEvent(new Event('blur'));
  };
  fields['gleason1_pros'].current.onchange = () => {
    calcGleason();
  };
  fields['gleason2_pros'].current.onchange = () => {
    calcGleason();
  };
};

export default cancerDeProstataChange;
